import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=bc13c578&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc13c578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc13c578')) {
      api.createRecord('bc13c578', component.options)
    } else {
      api.reload('bc13c578', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=bc13c578&scoped=true&", function () {
      api.rerender('bc13c578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-87hldBkOpOkAk/JS/comp/Accordion.vue"
export default component.exports